<div
  class="d-flex flex-column justify-content-between flex-grow-1 flex-shrink-1"
  role="document"
  aria-labelledby="confirmation-title"
>
  <div>
    <div class="fgbcl-confirmation-header">
      <div class="fgbcl-rewards-purchase-confirmation-title" id="confirmation-title">{{ 'lotto.confirm.text' | translate }}</div>
    </div>
    <div class="fgbcl-confirmation-body">
      <ng-container *fgbWebsiteContentFeatureFlag="'fgbcl.feature.flag.confirmation.additional'">
        <div class="font-size-14 text-black fw-bold rewards-confirmation-additional">
          {{ 'lottos.confirmation.additional' | translate }}
        </div>
      </ng-container>
      <div class="confirmation-details-section">
        <img
          class="confirm-modal-image"
          src="{{ lottoItem.ImageName | contentImage: '7' : 'lotto' }}"
          [alt]="lottoItem.Title"
        />
        <div class="fgbcl-confirmation-details">
          <div class="purchase-confirmation-name">{{ lottoItem.Title }}</div>
          @if (customFields?.length > 0) {
            <div class="lotto-modal-custom-fields">
              @for (field of customFields; track field.customFieldId) {
                <div class="lotto-modal-custom-field">
                  <span class="custom-field-name">{{ field.customFieldName }}: </span>
                  @switch (field.customValidationType) {
                    @case (CustomFieldType.Date) {
                      <span class="custom-field-value">{{ field.customFieldValue | UtcToLocaltimePipe: dateOptions?.NgbDateFormat }}</span>
                    }
                    @default {
                      <span class="custom-field-value">{{ field.customFieldValue }}</span>
                    }
                  }
                </div>
              }
            </div>
          }
          <div class="lotto-modal-entries">
            <span class="quantity-title mpc-confirmation-spacing">{{ 'lotto.entries' | translate }}</span>
            <span class="fw-bold lotto-modal-entries-total">{{ quantity | number }}</span>
          </div>
          <div class="lotto-modal-points-value">
            <span class="point-title mpc-confirmation-spacing">{{ 'lotto.points.value' | translate }}</span>
            @if (lottoItem.PurchasePrice > 0) {
              <span
                class="lotto-modal-price"
                [attr.aria-label]="(lottoItem.PurchasePrice * quantity | number) + ' points'"
              >
                {{ lottoItem.PurchasePrice * quantity | number }} {{ 'fgbcl.currency.pts' | translate }}
              </span>
            } @else {
              <span class="lotto-modal-price" aria-label="Free entry">{{ 'fgbcl.lottos.item.free' | translate }}</span>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="fgbcl-confirmation-footer">
    <button id="cancel-button" type="button" class="fgbcl-confirmation-button btn btn-purchase-cancel" (click)="modal.close()">
      {{ 'modal.cancel' | translate }}
    </button>
    <button id="confirm-button" type="button" class="fgbcl-confirmation-button btn btn-purchase-confirm" (click)="enter()">
      {{ 'modal.confirm' | translate }}
    </button>
  </div>
</div>
